var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasDiscount)?_c('v-btn',{attrs:{"loading":_vm.loading,"color":"error","small":"","outlined":""},on:{"click":_vm.handleRemove}},[_vm._v("Remove Discount")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }